import React from 'react';
import { FormattedMessage } from 'react-intl';
import cls from 'classnames';
import './From.scss';

/**
 * @param {object} props
 * @param {boolean} value true => 外帶; false => 內用
 * @param {()=> {}} onClick
 * @param {boolean} disabled
 * @param {string} offMessage
 * @param {string} onMessage
 */

function CusSwitch({ value, children, onClick, disabled, offMessage, onMessage, ...props }) {
  offMessage = offMessage || 'switchButton.takeout';
  onMessage = onMessage || 'switchButton.dineIn';

  let checkVaule = val => {
    if (val === true) return true;
    if (val === false) return false;
    throw 'val error';
  };
  return (
    <div
      className={cls(
        'CusSwitch d-flex justify-content-center align-items-center',
        checkVaule(value) ? 'CusSwitch_on' : 'CusSwitch_off',
        disabled ? 'disabled' : ''
      )}
      onClick={() => {
        if (!disabled) {
          onClick(!checkVaule(value))
        }
      }}
    >
      {checkVaule(value) ? (
        <div className="mr-2 ml-1">
          <FormattedMessage id={offMessage} />
        </div>
      ) : null}
      <div className="CusSwitch__btn"></div>
      {!checkVaule(value) ? (
        <div className="ml-2 mr-1">
          <FormattedMessage id={onMessage} />
        </div>
      ) : null}
    </div>
  );
}

export { CusSwitch };
